import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'antd';
import _, { values } from 'lodash';
import $ from 'jquery';
import { toast } from 'react-toastify';
import { Checkbox, FormControlLabel } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import SubLayout from '../../components/Layout/SubLayout'
import strings from "./../../components/Language";
import { getToken, storeUserData } from './../../components/Util';
import LoaderContext from '../../components/Loader/LoaderContext.js';

import CheckboxIcon from './../../assets/images/icons/checkbox.png';
import CheckboxCheckedIcon from './../../assets/images/icons/checkbox-checked.png';
import { api } from '../../components/config/api.js';
import axios from 'axios';

class AutoTradeScreen extends React.Component {
    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        this.state = {
            lang: strings.getLanguage(),
            access_token: "",
            data: [],
            onStartloading: false,
            onStoploading: false,
            selectedBots: [],
            selectedMaxPairs: 3,
            // botOptions: ['DCA', 'AI', 'CTS'],
            botOptions: [
                { id: 0, value: 2, name: 'AI' },
                { id: 1, value: 0, name: 'CTS' },
            ],
            checkedList: [],
            maxPairsOptions: [
                { label: '1', value: '1' },
                { label: '2', value: '2' },
                { label: '3', value: '3' },
                { label: '4', value: '4' },
                { label: '5', value: '5' },
                { label: '6', value: '6' },
                { label: '7', value: '7' },
                { label: '8', value: '8' },
                { label: '9', value: '9' },
                { label: '10', value: '10' }
            ],
            isStart: false
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            this.setState({ access_token: token });
            setTimeout(() => {
                this.getData();
            });
        }
    }

    getData() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {
            setLoading(true);
            axios({
                method: 'GET',
                url: api.auto_trade,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {
                    self.setState({
                        data: ress.data.data,
                        selectedMaxPairs: ress.data.data.max_pairs || 3,
                        isStart: ress.data.data.status,
                        selectedBots: ress.data.data.bots.map((bot) => {
                            return self.state.botOptions.findIndex((option) => option.value === bot);
                        }).filter((index) => index !== -1),
                    });
                }
                setLoading(false);
                self.setState({ is_load: false });
            }).catch(function (e) {
                self.setState({ is_load: false });
                setLoading(false);
            });
        }
    };

    toggleCheckbox = (index) => {
        this.setState((prevState) => {
            const { selectedBots } = prevState;
            if (selectedBots.includes(index)) {
                return { selectedBots: selectedBots.filter((i) => i !== index) };
            } else {
                return { selectedBots: [...selectedBots, index] };
            }
        });
    };

    toggleSelectAll = () => {
        this.setState((prevState) => {
            const { botOptions, selectedBots } = prevState;
            if (selectedBots.length === botOptions.length) {
                return { selectedBots: [] };
            } else {
                return { selectedBots: botOptions.map((_, i) => i) };
            }
        });
    };

    onStartConfirm() {
        var self = this;
        if (this.state.onStartloading) {
            return false;
        }
        $.confirm({
            title: strings.confirm + '!',
            theme: 'dark',
            content: strings.are_you_sure_you + " want to start AI Trade",
            buttons: {
                somethingElse: {
                    text: strings.start,
                    btnClass: 'btn-success',
                    action: function () {
                        self.onFinish(api.auto_trade_store, 1);
                    }
                },
                cancel: function () {
                    //close
                },
            }
        });
    }

    onStop() {
        this.onFinish(api.auto_trade_store, 0);
    }

    onFinish(api_url, status = null) {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token && api_url && status != null) {
            self.setState({ onStartloading: true });
            setLoading(true);

            var json = {
                bots: this.state.selectedBots.map((index) => this.state.botOptions[index].value),
                max_pairs: this.state.selectedMaxPairs,
                status: status
            }

            axios({
                method: 'POST',
                url: api_url,
                data: json,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                setLoading(false);
                if (ress.data && ress.data.error === 200) {
                    toast.success(ress.data.message);
                    self.getData();
                    self.props.history.replace({ pathname: `/home` })
                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                }
                self.setState({ onStartloading: false });
            }).catch(function (e) {
                setLoading(false);
                self.setState({ onStartloading: false });
            });
        }
    }



    render() {
        const { selectedBots } = this.state;
        const checkAll = this.state.botOptions.length === selectedBots.length;
        const indeterminate = selectedBots.length > 0 && selectedBots.length < this.state.botOptions.length;
        return (
            <SubLayout data={{ "title": strings.AutoTrade }}>
                <div className='row justify-content-center' style={{ margin: 0, padding: 10 }}>
                    <div className='col-md-4 offset-md-4' style={{ margin: 10, backgroundColor: "#1e2333", minHeight: "75vh", borderRadius: 10, paddingBlock: 20 }}>
                        <div style={{}}>
                            <div style={{ marginBottom: 5 }}>
                                <label className='' style={{ color: "#FFFFFF", fontSize: 14 }}>{strings.Select_BOT}</label>
                            </div>
                            {/* Select All Button */}
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                                <Button
                                    onClick={this.toggleSelectAll}
                                    style={{ fontSize: 12, textAlign: "center", background: "linear-gradient(to bottom, #1f409d, #2d2463, #4e0f82)", padding: '2.5px 10px', cursor: "pointer", borderWidth: 0, borderRadius: 5, textTransform: "uppercase", color: "#fff" }}
                                >
                                    {checkAll ?
                                        <>
                                            <img src={CheckboxCheckedIcon} alt="Checkbox Checked" width={16} height={16} style={{ marginRight: 5, marginBottom: 2 }}></img>
                                            {strings.Uncheck_All_Bots}
                                        </>
                                        :
                                        <>
                                            <img src={CheckboxIcon} alt="Checkbox" width={16} height={16} style={{ marginRight: 5, marginBottom: 2 }}></img>
                                            {strings.All_Bots}
                                        </>
                                    }
                                </Button>
                            </div>

                            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                                {this.state.botOptions.map((option, index) => (
                                    <div
                                        key={`SELECT_BOT_${index}`}
                                        style={{
                                            borderRadius: 5, padding: "0px 10px",
                                            background: "linear-gradient(to bottom, #1f409d, #2d2463, #4e0f82)", color: "#fff", cursor: "pointer"
                                        }}
                                        onClick={() => this.toggleCheckbox(index)}
                                    >
                                        <FormControlLabel
                                            onClick={() => this.toggleCheckbox(index)}
                                            control={
                                                <Checkbox
                                                    checked={this.state.selectedBots.includes(index)}
                                                    onClick={() => this.toggleCheckbox(index)}
                                                    name={option.name}
                                                    style={{ color: "#fff", marginRight: 5 }}
                                                />
                                            }
                                            label={option.name}
                                        />
                                    </div>
                                ))}
                            </div>

                            <div style={{ marginTop: 20 }}>
                                <div style={{ marginBottom: 5 }}>
                                    <label className='' style={{ color: "#FFFFFF", fontSize: 14 }}>{strings.Max_Pairs}</label>
                                </div>
                                <div className='main_content'>
                                    <Select
                                        value={this.state.selectedMaxPairs}
                                        name={strings.Select_Max_Pairs}
                                        style={{ backgroundColor: "transparent", color: "#FFFFFF", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                                        label={strings.Select_Max_Pairs}
                                        onChange={(e) => this.setState({ selectedMaxPairs: e.target.value })}
                                    >
                                        {this.state.maxPairsOptions.map((item, index) => (
                                            <MenuItem value={item.value}>{item.label}</MenuItem>
                                        ))}
                                    </Select>
                                </div>
                            </div>

                            <div style={{ marginTop: 20 }}>
                                <div style={{ marginBottom: 8 }}>
                                    <label style={{ color: "#FFFFFF", fontSize: 14 }}>Status</label>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                                    <label style={{ color: "#FFFFFF", fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
                                        <input
                                            type="radio"
                                            name="status"
                                            value="start"
                                            checked={this.state.isStart === true || this.state.isStart === 1}
                                            onChange={() => this.setState({ isStart: 1 })}
                                            style={{ accentColor: "#56ab2f", width: 16, height: 16 }}
                                        />
                                        {strings.start}
                                    </label>
                                    <label style={{ color: "#FFFFFF", fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
                                        <input
                                            type="radio"
                                            name="status"
                                            value="stop"
                                            checked={this.state.isStart === false || this.state.isStart === 0}
                                            onChange={() => this.setState({ isStart: 0 })}
                                            style={{ accentColor: "#ff3d3d", width: 16, height: 16 }}
                                        />
                                        {strings.stop}
                                    </label>
                                </div>
                            </div>

                            <div style={{ marginTop: 20 }}>
                                <Button
                                    loading={this.state.onStartloading}
                                    className='full-width'
                                    onClick={() => (this.state.isStart === true || this.state.isStart === 1) ? this.onStartConfirm() : this.onStop()}
                                    style={{ opacity: this.state.onStartloading ? 0.7 : 1, textAlign: "center", background: "linear-gradient(to bottom, #d4fc79, #56ab2f, #56ab2f)", padding: 10, cursor: "pointer", borderWidth: 0, borderRadius: 5 }}
                                >
                                    <label style={{ color: "#FFFFFF", fontSize: 16, cursor: "pointer", textTransform: "uppercase" }}>
                                        {this.state.onStartloading ? strings.loading : strings.save}
                                    </label>
                                </Button>
                            </div>

                            <div style={{ marginTop: 25, marginBottom: 20 }}>
                                {strings.disclaimer}:
                                <div style={{ marginTop: 5, color: "#8E8E8E" }}>
                                    <div>{strings.auto_trade_disclaimer}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SubLayout >
        );
    }
}

export default AutoTradeScreen;
